import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";
import { ManagerType } from "../constants";

export default [
  {
    path: "/register",
    redirect: "/register",
    name: "Register",
    component: LAYOUT,
    meta: {
      order: 40,
      roles: ManagerType.Normal,
      title: "注册到机构",
    },
    children: [
      {
        path: "",
        name: "RegisterPage",
        component: () => import("@/views/register/RegisterPage.vue"),
        meta: {
          title: "注册到机构",
          icon: "game-icons:archive-register",
          roles: ManagerType.Normal,
        },
      },
    ],
  },
  {
    path: "/register-review",
    redirect: "/register-review",
    name: "RegisterReview",
    component: LAYOUT,
    meta: {
      order: 40,
      roles: ManagerType.OrganizationReviewer,
      title: "注册管理",
    },
    children: [
      {
        path: "",
        name: "RegisterReviewPage",
        component: () => import("@/views/register/RegisterReviewPage.vue"),
        meta: {
          title: "注册管理",
          icon: "game-icons:archive-register",
          roles: ManagerType.OrganizationReviewer,
        },
      },
    ],
  },
] as RouteRecordRaw[];
